import { Box, Paper, Skeleton } from "@mui/material";

export default function AnalyticsSkeleton() {
  return (
    <Box sx={{ mt: 3.5 }}>
      <Skeleton variant="text" width={220} height={32} />
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 2.5, mt: 2 }}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Paper key={index} variant="outlined" sx={{ p: "20px 22px", borderRadius: 2 }}>
            <Skeleton variant="text" width="60%" height={18} />
            <Skeleton variant="text" width="40%" height={40} />
            <Skeleton variant="text" width="70%" height={16} />
          </Paper>
        ))}
      </Box>
      <Skeleton variant="text" width={260} height={32} sx={{ mt: 3.75 }} />
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 2.5, mt: 2 }}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Paper key={index} variant="outlined" sx={{ p: "20px 22px", borderRadius: 2 }}>
            <Skeleton variant="text" width="60%" height={18} />
            <Skeleton variant="text" width="40%" height={40} />
            <Skeleton variant="text" width="70%" height={16} />
          </Paper>
        ))}
      </Box>
      <Box sx={{ display: "grid", gridTemplateColumns: "1.15fr 1fr", gap: 2.5, mt: 2.5 }}>
        <Paper variant="outlined" sx={{ p: "20px 24px", borderRadius: 2 }}>
          <Skeleton variant="text" width={200} height={24} />
          <Skeleton variant="rectangular" height={190} sx={{ mt: 1.5, borderRadius: 1 }} />
        </Paper>
        <Paper variant="outlined" sx={{ p: "20px 24px", borderRadius: 2 }}>
          <Skeleton variant="text" width={160} height={24} />
          {Array.from({ length: 4 }).map((_, index) => (
            <Skeleton key={index} variant="rectangular" height={22} sx={{ mt: 1.75, borderRadius: 1 }} />
          ))}
        </Paper>
      </Box>
      <Paper variant="outlined" sx={{ mt: 2.5, p: "20px 24px", borderRadius: 2 }}>
        <Skeleton variant="text" width={160} height={24} />
        <Skeleton variant="rectangular" height={240} sx={{ mt: 1.5, borderRadius: 1 }} />
      </Paper>
      <Paper variant="outlined" sx={{ mt: 2.5, p: "20px 24px", borderRadius: 2 }}>
        <Skeleton variant="text" width={160} height={24} />
        {Array.from({ length: 6 }).map((_, index) => (
          <Skeleton key={index} variant="rectangular" height={22} sx={{ mt: 1.75, borderRadius: 1 }} />
        ))}
      </Paper>
    </Box>
  );
}
